export function DoILikeIt(postId, likeList) {
    let response = 0;
    let checkLike = likeList.filter(a => a.PostId === postId);
    if (checkLike.length > 0) {
        response = checkLike[0].ActionType;
    }
    return response;
}